import { DiagnoseService } from './../../../../../../Service/DiagnoseService';
import { BasePanelController } from '../../../../../BaseUI/BasePanelController';
import { DiagnoseDetailPanelComponent } from './DiagnoseDetailPanelComponent';

export class DiagnoseDetailPanelController extends BasePanelController {

	// 検査詳細画面に対応するコントローラー
	public combineView: DiagnoseDetailPanelComponent;

	/**
	 * getDiagnoseDetailData
	 * 検査詳細PDFの取得
	 * @param param ファイルID
	 * @returns ファイルURL
	 */
	public async getDiagnoseDetailData(param: { view: any; fileId: any }) {

		const svc = new DiagnoseService(param.view);
		const ret = await svc.getDiagnoseDetail(param.fileId);

		return ret;

	}



}
